import { render, staticRenderFns } from "./Sifrant.vue?vue&type=template&id=63970b04&"
import script from "./Sifrant.vue?vue&type=script&lang=js&"
export * from "./Sifrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports